








































































































































// @ is an alias to /src
import { Component, Emit, Vue } from "vue-property-decorator";
import VModal from "vue-js-modal";
import Formulario from "@/components/Formulario.vue";
import Promotion from "@/components/Promotion.vue";
import Navbar from "@/components/Navbar.vue";
import ModelSelector from "@/components/modelSelector.vue";
import VesionsCarsCards from "@/components/versionesAutos.vue";

@Component({
  components: {
    Navbar,
    ModelSelector,
    VesionsCarsCards,
  },
})
export default class Ignis extends Vue {
  @Emit()
  openModalDetalle(
    auto: string,
    titulo: string,
    interes: string,
    version: string
  ) {
    return {
      auto: auto,
      titulo: titulo,
      interes: interes,
      version: version,
    };
  }

  openModelSelector(): void {
    let curtainForm = document.getElementById("curtain-formM");
    let menuForm = document.getElementById("menu-formM");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formM");
    menuForm?.classList.add("open-menu-formM");
  }

  public showModal(): void {
    this.$modal.show(
      "contactModal",
      {},
      {
        height: "auto",
        scrollable: true,
      }
    );
  }

  expand: boolean = true;
  toggleExpand() {
    this.expand = !this.expand;
  }
  openPurebaManejoTw() {
    document.getElementById("PMtiket")!.click();
  }
  mounted() {
    let tiket = this.$route.query.variableName;
    this.$router.push({ query: { variableNavName: "JIMNY" } });
    if (tiket == "1") {
      setTimeout(function () {
        document.getElementById("tiket")!.click();
      }, 1000);
    }
    if (tiket == "2") {
      setTimeout(function () {
        document.getElementById("PMtiket")!.click();
      }, 1000);
    }
  }
  scrollState(state: string) {
    const elem = document.getElementById("scrollBlock");
    elem!.style.overflow = state;
  }
}
